import PostBox from "components/posts/PostBox";
import { AuthContext } from "context/AuthContext";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import useTranslation from "hooks/useTranslation";
import { PostProps } from "pages/home";
import { useContext, useEffect, useState } from "react";

export default function Search() {
    const [posts, setPosts] = useState<PostProps[]>([]);
    const [tagQuery, setTagQuery] = useState<string>("");
    const { user } = useContext(AuthContext);
    const t = useTranslation();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {
            currentTarget: { value },
        } = e;
        setTagQuery(value.trim());
    };

    useEffect(() => {
        if (user) {
            let postRef = collection(db, "posts");
            let postsQuery = query(
                postRef,
                where("hashTags", "array-contains-any", [tagQuery]),
                orderBy("createdAt", "desc")
            );

            onSnapshot(postsQuery, (snapShot) => {
                let dataObj = snapShot?.docs?.map((doc) => ({
                    ...doc?.data(),
                    id: doc?.id,
                }));
                setPosts(dataObj as PostProps[]);
            });
        }
    }, [user, tagQuery]);

    return (
        <div className="home">
            <div className="home__top">
                <div className="home__title">
                    <div className="home__title-text">{t("MENU_SEARCH")}</div>
                </div>
                <div className="home__search-div">
                    <input
                        type="text"
                        className="home__search"
                        placeholder={t("SEARCH_HASHTAGS")}
                        value={tagQuery}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className="post">
                {posts.length > 0 ? (
                    posts.map((post) => <PostBox post={post} key={post.id} />)
                ) : (
                    <div className="post__no-posts">
                        <div className="post__text">게시글이 없습니다.</div>
                    </div>
                )}
            </div>
        </div>
    );
}
